import { mapGetters } from 'vuex'
import { axiosGet, axiosPost } from '../../axios/axios.js'
import { getRequestStateName } from '../../components/helpers.js'
import { changeBPState } from '../../components/ChangePBState.js'
import { createRequestWithDefaultFields, convertRequestToServer } from '../Request/Request.js'
import { requestActionsCancelAssignment } from '../Request/RequestActionsCancelAssignment.js'
import { requestBackdateActions } from '../Request/RequestBackdateActions.js'
import { getObjectAdditionalInfo } from '../Request/RequestGetObjectAdditionalInfo.js'
import { getServiceObjectCheckResult, getAuditRequestServiceObjectCheckResult } from '../Request/RequestServiceObjectsCheck.js'
import AdditionalDepartureRequiredCard from './AdditionalDepartureRequiredCard.vue'
import { checkDeferralAccess, shouldBlockLoadedReport, showPreviousDeferredReportWarning } from '../Report/ReportActions.js'
import CompleteWorksCard from './CompleteWorksCard.vue'
import TasksAcceptWindow from './TasksAcceptWindow.vue'
import { getExtendedVehicleName } from '../../forms/Brigade/BrigadeForkliftTruck/BrigadeForkliftTruckField.js'
import { closeRequest } from './TaskActionsCloseRequest.js'
import { fastFixServiceObjectMaintenanceNotes } from '../ServiceObjectMaintenanceNote/ServiceObjectMaintenanceNotesFastFix.js'
import { loadNotes } from '../ServiceObjectMaintenanceNote/ServiceObjectMaintenanceNotesTable.js'
import ServiceObjectMaintenanceNotesTaskAccept from '../ServiceObjectMaintenanceNote/ServiceObjectMaintenanceNotesTaskAccept.vue'
import RequestAdjacentObjectsRequests from '../Request/RequestAdjacentObjectsRequests.vue'
import { requestActionsAskAdjacentRequests } from '../Request/RequestActionsAskAdjacentRequests.js'
import RequestsExpansionWorksWithWarnings from '../../pages/engineer/EngineerTasks/RequestsExpansionWorksWithWarnings.vue'
import { MGT_TASK_CANCEL_REASON_OPTIONS } from '../Request/RequestMgtUtils.js'

export const taskActions = {
  mixins: [requestActionsCancelAssignment, requestBackdateActions, getObjectAdditionalInfo, changeBPState, closeRequest, fastFixServiceObjectMaintenanceNotes, requestActionsAskAdjacentRequests],
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    taskStatus: {
      type: String,
      default: ''
    },
    requestRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    reportRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    bpDocuments: {
      type: Array,
      default: null
    },
    isAudit: {
      type: Boolean,
      default: false
    },
    hasNotTransmittedFinishReport: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      reworkButtons: [
        { title: 'Доработка отчёта', key: 'reworkReport' },
        { title: 'Доработка объекта', key: 'reworkServiceObject' }
      ],
      defaultTask: null,
      modalAuditOpened: false,
      modalInitializeOpened: false
    }
  },
  computed: {
    ...mapGetters({
      taskStatesColors: 'getTaskStatesColors',
      user: 'getUser'
    }),
    isAuditObject: function () {
      return !!(this.isAudit && this.request.auditObject === true)
    },
    isAuditWorks: function () {
      return !!(this.isAudit && this.request.audit === true)
    },
    requestId: function () {
      if (this.request) {
        return this.request.requestId
      } else if (this.report) {
        return this.report.requestId
      } else {
        return null
      }
    },
    isContractor: function () {
      const user = this.user
      return !!(user && user.employee && user.employee.isContractor)
    },
    isContractorDispatcher: function () {
      const user = this.user
      return !user.roles.root && user.hasRole('contractorDispatcher') // user.roles.contractorDispatcher
    },
    isContractorAssigned: function () {
      return (!!this.request.assignedBrigade && !!this.request.assignedBrigade.contractor || !!this.request.assignedEmployee && !!this.request.assignedEmployee.contractor)
    },
    isLastReportDeferred: function () {
      return !!(this.request && this.request.reportState === 'PR11')
    }
  },
  methods: {
    onAuditTaskCreated: function (result) {
      this.modalAuditOpened = false
      this.$router.push('/task/' + result.id + '/document/' + result.id)
    },
    onInitializeTaskCreated: function (result) {
      this.$emit('task-updated')
      this.modalInitializeOpened = false
    },
    getButtonStylesByTaskStatus: function (bpStateId) {
      let bgColor = this.taskStatesColors[bpStateId]
      if (bgColor == null) {
        bgColor = '#0000FF'
      }
      let style = 'font-weight: bold !important; background-color: ' + bgColor + ';'

      if (bgColor === '#0000FF' || bgColor === '#828282' || bgColor === '#FF0000') {
        style += ' color: white;'
      } else {
        style += ' color: black;'
      }

      return style
    },
    getButtonNameByTaskStatus: function (bpStateId) {
      return getRequestStateName(bpStateId, this.request)
    },

    /*
      ДЕЙСТВИЯ ПРИ НАЖАТИИ НА КНОПКИ
    */
    initializeRequest: async function () {
      const user = this.$store.getters.getUser
      this.defaultTask = createRequestWithDefaultFields(user)
      this.defaultTask.initiatorRequests.push({ id: this.request.requestId, name: this.request.name })
      this.defaultTask.serviceObject = this.request.serviceObject
      this.defaultTask.serviceObjectPriority = this.request.serviceObjectPriority
      this.defaultTask.location = this.request.location
      this.defaultTask.requestAddress = this.request.requestAddress

      const serviceObjectId = this.request.serviceObjectId
      if (serviceObjectId) {
        const checkResult = await getServiceObjectCheckResult.call(this, serviceObjectId, true) // before creation
        if (!checkResult.continueAction) {
          return
        }
      }
      this.defaultTask._checkedServiceObjectId = serviceObjectId

      this.modalInitializeOpened = true
    },
    createSynchronizedRequest: async function (synchronizedRequestWorkArea) {
      const user = this.$store.getters.getUser
      this.defaultTask = createRequestWithDefaultFields(user)
      this.defaultTask.synchronizeTargetRequest = this.request.requestId
      this.defaultTask.synchronizedRequestWorkArea = synchronizedRequestWorkArea

      if (this.request.serviceObject && this.request.serviceObject.relatedObject) {
        this.defaultTask.serviceObject = this.request.serviceObject.relatedObject
        this.defaultTask.location = this.request.serviceObject.relatedObject.location
        this.defaultTask.requestAddress = this.request.serviceObject.relatedObject.address
      }

      const serviceObjectId = this.request.serviceObjectId
      if (serviceObjectId) {
        const checkResult = await getServiceObjectCheckResult.call(this, serviceObjectId, true) // before creation
        if (!checkResult.continueAction) {
          return
        }
      }

      if (synchronizedRequestWorkArea) {
        this.$q.loading.show({ spinnerColor: 'blue-11' })

        const filter = await axiosGet({
          url: '/service/delta/dispatcher/getfilter?type=common&formId=synchronizedRequest',
          onSuccess: response => response.data
        })

        filter.workArea.values.forEach(workArea => {
          workArea.selected = workArea.key === synchronizedRequestWorkArea.key
        })

        const bodyFormData = new FormData()
        bodyFormData.set('data', JSON.stringify(filter))
        await axiosPost({
          url: '/service/delta/dispatcher/setfilter?type=common&formId=synchronizedRequest',
          data: bodyFormData
        })

        this.$q.loading.hide()
      }

      this.defaultTask._checkedServiceObjectId = serviceObjectId

      this.modalInitializeOpened = true
    },
    audit: async function () {
      const requestId = this.request.requestId
      const checkResult = await getAuditRequestServiceObjectCheckResult.call(this, requestId) // before audit
      if (!checkResult.continueAction) {
        return
      }

      const user = this.$store.getters.getUser
      this.defaultTask = createRequestWithDefaultFields(user)
      this.defaultTask.requestToAudit = this.request.requestId
      this.defaultTask.serviceObject = this.request.serviceObject
      this.modalAuditOpened = true
    },
    createReportRoads: function () {
      this.$q.loading.show({ spinnerColor: 'blue-11' })
      axiosGet({
        url: '/service/delta/finishreport/create/' + this.request.requestId,
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Создан отчёт для Roads',
            progress: true,
            timeout: 3000
          })

          this.$emit('report-roads-created')
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        }
      }).finally(() => this.$q.loading.hide())
    },
    createOrderAdmittance: function () {
      const bodyFormData = new FormData()
      bodyFormData.set('props', JSON.stringify({ request: this.request.requestId }))

      axiosPost({
        url: '/service/delta/orderadmittance/AD1',
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Создан наряд-допуск',
            progress: true,
            timeout: 3000
          })

          this.$emit('task-created')
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        }
      })
    },
    BS2_AnalyzeRequest: function () {
      if (this.taskStatus === 'BS3' || this.taskStatus === 'BS4') {
        this.onCancelAssignment(() => {
          this.$emit('task-updated')
        })
      } else {
        this.changePBState('BS2', null, 'Ошибка взятия заявки в анализ')
      }
    },
    BS4_acceptTaskForExecutionWithAsk: function () {
      const user = this.user
      const acceptAsDispatcher = user.view !== 'mobile' || this.isContractorDispatcher
      if (acceptAsDispatcher) {
        this.BS4_acceptTaskForExecutionDispatcherWithAsk()
      } else {
        this.BS4_acceptTaskForExecutionMobile()
      }
    },
    BS4_acceptTaskForExecutionMobile: async function (data, additionalCheck = true) {
      const request = [...this.$store.getters.getRequests, ...this.$store.getters.getClosestRequests].find((request) => request.id === this.request.id)
      const brigade = this.$store.getters.getBrigade

      let continueAssignment = true
      if (brigade && additionalCheck) {
        this.$q.loading.show({ spinnerColor: 'blue-11' })
        const activeBrigadeOnServiceObject = await this.checkObjectHasActiveBrigade(request.id, brigade.id)

        if (activeBrigadeOnServiceObject !== '') {
          this.$q.loading.hide()
          continueAssignment = await new Promise((resolve, reject) => {
            this.$d_ask({
              callback: (data, action) => {
                resolve(action === 'yes')
              },
              header: activeBrigadeOnServiceObject,
              buttons: {
                yes: 'Принять к исполнению',
                no: 'Отмена'
              }
            })
          })
        }
      }

      if (additionalCheck) {
        if (this.request.hasAdjacentRequest) {
          this.$q.loading.hide()
          continueAssignment = await this.askAdjacentRequests('Принять к исполнению')
        }
      }

      if (continueAssignment && additionalCheck && request.showMaintenanceNote) {
        this.$q.loading.show({ spinnerColor: 'blue-11' })
        const sourceProps = { recordSource: 'serviceObject', serviceObjectId: request.serviceObjectId, serviceObjectName: request.serviceObjectName, serviceObjectType: request.serviceObjectType, id: request.id }
        const notes = await loadNotes(sourceProps)
        const notFixiedNotes = notes.filter(note => note.maintenanceNoteStatus && note.maintenanceNoteStatus.key === 'notFixed')
        this.$q.loading.hide()

        if (notFixiedNotes && notFixiedNotes.length) {
          continueAssignment = await new Promise((resolve, reject) => {
            const dialog = this.$d.dialog(this).show({
              maximized: false,
              persistent: true,
              headerHidden: true,
              contentComponent: ServiceObjectMaintenanceNotesTaskAccept,
              contentProps: {
                sourceProps: sourceProps,
                simpleMobile: true
              },
              componentHandlers: {
                close: () => {
                  dialog.hide()
                  resolve(false)
                },
                accept: () => {
                  dialog.hide()
                  resolve(true)
                }
              }
            })
          })
        }
      }

      if (continueAssignment) {
        this.$q.loading.show({ spinnerColor: 'blue-11' })
        const url = '/service/delta/requestBusinessProcess/special/acceptForExecution?id=' + request.bpCtxId
        const bodyFormData = new FormData()
        if (data) {
          if (data.requests) {
            bodyFormData.set('requests', JSON.stringify(data.requests))
          }
          if (data.vehicleProvisionRequests) {
            bodyFormData.set('vehicleProvisionRequests', JSON.stringify(data.vehicleProvisionRequests))
          }
          if (data.force) {
            bodyFormData.set('force', 'true')
          }
        }
        if (request.urgent) {
          bodyFormData.set('urgent', true)
        }
        if (request.closestRequest) {
          bodyFormData.set('nearby', true)
        }

        return axiosPost({
          url: url,
          data: bodyFormData,
          onSuccess: (response) => {
            this.$q.loading.hide()

            const warnings = []
            if (this.request.objectStatusCode === 'reconstruction') {
              const objectAlias = this.request.objectAlias || 'Объект'
              warnings.push(objectAlias + ' находится на реконструкции')
            } else if (this.request.objectStatusCode === 'serviceSuspended') {
              const objectAlias = this.request.objectAlias || 'объекта'
              warnings.push(`Обслуживание ${objectAlias} приостановлено`)
            } else if (this.request.objectStatusCode === 'damageReportGenerated') {
              const objectAlias = this.request.objectAlias || 'объекту'
              warnings.push(`По ${objectAlias} составлен акт повреждений`)
            }
            if (response.data.warnings && response.data.warnings.length) {
              warnings.push(...response.data.warnings)
            }

            const requests = response.data.result.requests || []

            const forkLifts = response.data.vehicleProvisionRequests || []
            if (forkLifts.length) {
              warnings.push('У вас есть назначенная спецтехника:')
            }

            let header = 'Принять к исполнению Заявку №' + request.key + '?'

            if (response.data.code === 'processMultiple') {
              const proposal = response.data.result
              const objectAlias = proposal.requests && proposal.requests.length ? proposal.requests[0].objectAlias : 'объект Б/Н'
              this.$d.dialog(this).show({
                maximized: true,
                persistent: true,
                headerLabel: 'Задания на ' + objectAlias,
                contentComponent: TasksAcceptWindow,
                contentProps: {
                  proposal: proposal,
                  callback: (data, confirmed) => {
                    if (confirmed) {
                      if (forkLifts.length > 0 || warnings.length > 0) {
                        return this.BS4_acceptTaskForExecutionMobileWithAdditionalInfo(data, forkLifts, warnings, header)
                      } else {
                        return this.BS4_acceptTaskForExecutionMobile(data, false)
                      }
                    }
                    return Promise.resolve()
                  }
                }
              })
            } else if (response.data.code === 'processUrgent') {
              header = 'Принять к исполнению Заявку №' + request.key + (request.acceptedRequestKey ? ' вместо Заявки №' + request.acceptedRequestKey : '') + '?'
              return this.BS4_acceptTaskForExecutionMobileWithAdditionalInfo({ force: true }, forkLifts, warnings, header, requests)
            } else if (response.data.code === 'processSimple') {
              return this.BS4_acceptTaskForExecutionMobileWithAdditionalInfo({ force: true }, forkLifts, warnings, header, requests)
            } else if (response.data.code === 'processNearby') {
              header = 'Принять к исполнению Заявку №' + request.key + (response.data.assignedOnAnotherExecutor ? ', назначенную на другого исполнителя' : '') + '?'
              return this.BS4_acceptTaskForExecutionMobileWithAdditionalInfo({ force: true }, forkLifts, warnings, header, requests)
            } else if (response.data.code === 'changeAcceptedObject') {
              header = 'Уже принята к исполнению заявка на объекте ' + response.data.activeObjectName + '. Переключиться на Заявку №' + request.key + ' на ' + response.data.objectName + '?'
              return this.BS4_acceptTaskForExecutionMobileWithAdditionalInfo({ force: true }, forkLifts, warnings, header, requests)
            } else if (response.data.code === 'askMultipleReportInclusion') {
              this.$d_ask({
                callback: (data, action) => {
                  if (action === 'yes' || action === 'no') {
                    data = {
                      bpContextId: request.bpCtxId,
                      accepted: true,
                      multiReportItem: (action === 'yes')
                    }

                    if (forkLifts.length > 0 || warnings.length > 0 || requests.length > 0) {
                      return this.BS4_acceptTaskForExecutionMobileWithAdditionalInfo(data, false, forkLifts, warnings, header, requests)
                    } else {
                      return this.BS4_acceptTaskForExecutionMobile(data, false)
                    }
                  }
                },
                header: 'Включить в сводный отчёт?',
                buttons: {
                  yes: 'Да',
                  no: 'Нет',
                  cancel: 'Отмена'
                }
              })
            } else if (forkLifts.length > 0 || warnings.length > 0 || requests.length > 0) {
              return this.BS4_acceptTaskForExecutionMobileWithAdditionalInfo({ }, forkLifts, warnings, header, requests)
            } else {
              this.$emit('task-updated', { checkNewReport: true })

              const notifyText = 'Статус документа ' + '"' + request.name + '" (' + (request.object || 'Б/Н') + ')' +
                ' изменен на "' + response.data.result.stateName + '"'

              this.$q.notify({
                type: 'positive',
                message: notifyText,
                progress: true,
                timeout: 3000
              })
            }
          },
          onFailure: (response) => {
            const code = (response && response.code) || null
            if (code === 'expired') {
              this.$d_ask({
                callback: () => {
                  this.$emit('task-updated')
                },
                header: 'Статус задания изменился,<br>требуется обновить список заданий',
                buttons: {
                  yes: 'Обновить',
                  cancel: 'Отмена'
                }
              })
            } else {
              this.$q.notify({
                type: 'negative',
                message: response.message,
                progress: true,
                timeout: 8000
              })
              return Promise.reject(new Error('Ошибка принятия заявки к исполнению'))
            }
          }
        }).finally(() => this.$q.loading.hide())
      } else {
        this.$q.loading.hide()
        return Promise.resolve()
      }
    },
    onAcceptUrgentTask: function () {
      this.$q.loading.show({ spinnerColor: 'blue-11' })
      const brigade = this.$store.getters.getBrigade

      axiosGet({
        url: '/service/delta/brigade/acceptUrgentRequest?id=' + brigade.id,
        onSuccess: (response) => {
          this.$emit('task-updated')

          this.$q.notify({
            type: 'positive',
            message: response.message || 'Успешно принята к исполнению',
            progress: true,
            timeout: 3000
          })

          this.$q.loading.hide()
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.details || response.message,
            progress: true,
            timeout: 8000
          })

          this.$q.loading.hide()
        }
      })
    },
    BS4_acceptTaskForExecutionDispatcherWithAsk: function () {
      this.$d_ask({
        callback: () => {
          this.BS4_acceptTaskForExecutionDispatcher()
        },
        header: 'Принять заявку к исполнению?'
      })
    },
    BS4_acceptTaskForExecutionMobileWithAdditionalInfo: function (params, forkLifts = [], warnings, header, requests = []) {
      const propsConfig = {}
      if (forkLifts.length) {
        forkLifts.forEach((forkLift) => {
          if (forkLift.actionType === 'relocationStart' || forkLift.actionType === 'relocationEnd' || forkLift.actionType === 'deliveryParametersChange') {
            propsConfig[forkLift.id + '_separator_start'] = {
              type: 'separator',
              label: getExtendedVehicleName(forkLift)
            }
          }
          if (forkLift.actionType === 'relocationStart') {
            propsConfig[forkLift.id] = {
              label: 'Начать передислокацию',
              type: 'boolean',
              value: true
            }
          } else if (forkLift.actionType === 'relocationEnd') {
            propsConfig[forkLift.id] = {
              label: 'Завершить передислокацию',
              type: 'boolean',
              value: true
            }
          } else if (forkLift.actionType === 'deliveryParametersChange') {
            propsConfig[forkLift.id + '_' + 'apply'] = {
              label: 'Изменить адрес и время подачи',
              type: 'boolean',
              value: false
            }
            propsConfig[forkLift.id + '_' + 'time'] = {
              label: 'Время подачи',
              type: 'datetime',
              value: forkLift.serviceTime,
              disableFn: (propsConfig) => !propsConfig[forkLift.id + '_' + 'apply'] || !propsConfig[forkLift.id + '_' + 'apply'].value
            }
          }
          if (forkLift.actionType === 'relocationStart' || forkLift.actionType === 'relocationEnd' || forkLift.actionType === 'deliveryParametersChange') {
            propsConfig[forkLift.id + '_separator_end'] = {
              type: 'separator',
              label: ''
            }
          }
        })
      }
      return new Promise((resolve) => {
        this.$d_ask({
          callback: (data, action) => {
            if (action === 'yes') {
              if (forkLifts.length) {
                const convertedForkLifts = []
                forkLifts.forEach((forkLift) => {
                  if (forkLift.actionType === 'relocationStart') {
                    convertedForkLifts.push({
                      id: forkLift.id,
                      apply: data[forkLift.id]
                    })
                  } else if (forkLift.actionType === 'relocationEnd') {
                    convertedForkLifts.push({
                      id: forkLift.id,
                      apply: data[forkLift.id]
                    })
                  } else if (forkLift.actionType === 'deliveryParametersChange') {
                    convertedForkLifts.push({
                      id: forkLift.id,
                      apply: data[forkLift.id + '_' + 'apply'],
                      time: data[forkLift.id + '_' + 'time']
                    })
                  }
                })

                params = {
                  ...params,
                  vehicleProvisionRequests: convertedForkLifts
                }
              }

              resolve(this.BS4_acceptTaskForExecutionMobile(params, false))
            }
          },
          header: header,
          warning: warnings,
          propsConfig: propsConfig,
          customComponent: requests.length > 0 ? RequestsExpansionWorksWithWarnings : null,
          customComponentProps: {
            requests: requests,
            defaultOpened: true
          },
          buttons: {
            yes: 'Подтвердить',
            cancel2: 'Отмена'
          }
        })
      })
    },
    BS4_acceptTaskForExecutionDispatcher: async function () {
      let continueAccept = true
      if (this.request.hasAdjacentRequest) {
        this.$q.loading.hide()
        continueAccept = await this.askAdjacentRequests('Принять к исполнению')
      }
      if (continueAccept) {
        return axiosGet({
          url: '/service/delta/requestBusinessProcess/BS4?objectId=' + this.request.bpContextId,
          onSuccess: (response) => {
            this.$q.notify({
              type: 'positive',
              message: 'Заявка принята к исполнению',
              progress: true,
              timeout: 3000
            })

            this.$emit('task-updated', { checkNewReport: true })
          },
          onFailure: (response) => {
            this.$q.notify({
              type: 'negative',
              message: response.message,
              progress: true,
              timeout: 8000
            })
          }
        })
      } else {
        return Promise.reject(new Error('Ошибка принятия заявки к исполнению'))
      }
    },
    BS9_ReopenRequest: function () {
      this.$d_ask({
        callback: data => {
          this.changePBState('BS9', data, 'Ошибка повторного открытия заявки')
        },
        header: 'Повторное открытие заявки',
        propsConfig: {
          reason: { type: 'text', label: 'Причина', required: true }
        }
      })
    },
    BS10_RequireAdditionalDeparture: function () {
      this.$d.dialog(this).show({
        maximized: false,
        persistent: true,
        headerLabel: getRequestStateName('BS10', this.request), // 'Требуется дополнительный выезд'
        contentComponent: AdditionalDepartureRequiredCard,
        contentProps: {
          request: this.request,
          requestRoles: this.requestRoles,
          executorSelection: true,
          callback: (data, confirmed) => {
            if (confirmed) {
              return this.changePBState('BS10', data, 'Ошибка изменения статуса заявки')
            }
            return Promise.resolve()
          }
        }
      })
    },
    BS11_PutRequestUnderControl: function () {
      this.$d_ask({
        callback: data => {
          if (this.taskStatus === 'BS4') {
            data.reportDeletionConfirmed = true
          }
          this.changePBState('BS11', data, 'Не удалось отложить работы')
        },
        header: 'Отложенное продолжение работ',
        propsConfig: {
          reason: { type: 'text', label: 'Причина', required: true }
        },
        warning: this.getChangePBStateWarnings('BS11')
      })
    },
    BS12_RejectRequest: function (event, navigateFn, loadingActivity) {
      const warnings = []
      let reason = null
      let reasonOptions = null
      let cancelSupTask = false
      const supCancelInfo = this.request.supTaskData && this.request.supTaskData.cancelInfo || null
      if (this.request.id && supCancelInfo && !supCancelInfo.cancelled) {
        if (supCancelInfo.cancelAvailable) {
          cancelSupTask = true
          warnings.push('Будет отменена задача ПТК АПТС')

          reasonOptions = MGT_TASK_CANCEL_REASON_OPTIONS
          reason = MGT_TASK_CANCEL_REASON_OPTIONS[0]
        } else {
          let warning = 'Задача ПТК АПТС останется в статусе "' + supCancelInfo.statusName + '".'
          if (supCancelInfo.statusTimeoutExceeded) {
            warning = warning + ' Истек разрешенный срок изменений (30 дней)'
          } else {
            warning = warning + ' Статус не удовлетворяет условиям отмены'
          }
          warnings.push(warning)
        }
      }

      const actionName = 'Отклонение заявки'
      this.$d_ask({
        callback: data => {
          this.askProcessGroup(
            (props) => {
              data = data == null ? props : Object.assign(data, props)
              if (this.taskStatus === 'BS4') {
                data.reportDeletionConfirmed = true
              }

              loadingActivity && loadingActivity.startLoading(actionName)
              this.changePBState('BS12', data, null, (response) => {
                let message
                let caption
                if (response.code === 'timeout' && cancelSupTask) {
                  message = 'Истек таймаут запроса отмены задачи ПТК АПТС'
                  caption = 'Повторите операцию, при повторной ошибке обратитесь к администратору.'
                } else {
                  message = 'Ошибка отклонения заявки'
                  caption = response.message
                }

                this.$q.notify({
                  type: 'negative',
                  message: message,
                  caption: caption,
                  timeout: 8000,
                  progress: true
                })
                return Promise.reject(new Error(response.message || message))
              })
                .finally(() => {
                  loadingActivity && loadingActivity.stopLoading()
                })
            },
            (this.request.group != null)
          )
        },
        header: actionName,
        propsConfig: {
          reason: { type: 'text', label: 'Причина', required: true, value: reason, options: reasonOptions }
        },
        warning: this.getChangePBStateWarnings('BS12', warnings)
      })
    },
    BS13_RejectRequestAsContractorWithAsk: function () {
      this.$d_ask({
        callback: (data) => {
          if (this.taskStatus === 'BS4') {
            data.reportDeletionConfirmed = true
          }
          this.BS13_RejectRequestAsContractor(data)
        },
        header: 'Отклонить заявку?',
        propsConfig: { reason: { type: 'text', label: 'Причина', required: true } },
        warning: this.getChangePBStateWarnings('BS13')
      })
    },
    BS13_RejectRequestAsContractor: function (data) {
      this.askProcessGroup(
        (props) => {
          data = data == null ? props : Object.assign(data, props)
          this.changePBState('BS13', data, 'Ошибка отклонения заявки')
        },
        (this.request.group != null)
      )
    },
    BS17_closeRequest: async function (event, navigateFn, loadingActivity) {
      if (this.taskStatus === 'BS4') {
        this.$d_ask({
          callback: (data) => {
            if (this.taskStatus === 'BS4') {
              data.reportDeletionConfirmed = true
            }
            data.checkRequestCondition = true
            this.closeRequest(this.request.bpContextId, data, loadingActivity)
              .then((result) => {
                if (result !== 'cancel') {
                  this.$emit('task-updated')
                }
              })
          },
          header: 'Закрыть заявку?',
          warning: this.getChangePBStateWarnings('BS17')
        })
      } else {
        this.closeRequest(this.request.bpContextId, { checkRequestCondition: true }, loadingActivity)
          .then((result) => {
            if (result !== 'cancel') {
              this.$emit('task-updated')
            }
          })
      }
    },
    BS18_withdrawRequest: function () {
      this.$d_ask({
        callback: data => {
          this.askProcessGroup(
            (props) => {
              data = data == null ? props : Object.assign(data, props)
              if (this.taskStatus === 'BS4') {
                data.reportDeletionConfirmed = true
              }
              this.changePBState('BS18', data, 'Ошибка отзыва заявки')
            },
            (this.request.group != null)
          )
        },
        header: 'Отозвать заявку?',
        propsConfig: {
          reason: { type: 'text', label: 'Причина', required: true }
        },
        warning: this.getChangePBStateWarnings('BS18')
      })
    },
    BS19_DelayRequest: function () {
      this.$d_ask({
        callback: data => {
          this.askProcessGroup(
            (props) => {
              data = data == null ? props : Object.assign(data, props)
              if (this.taskStatus === 'BS4') {
                data.reportDeletionConfirmed = true
              }
              this.changePBState('BS19', data, 'Не удалось отложить заявку')
            },
            (this.request.group != null)
          )
        },
        header: 'Отложить заявку?',
        propsConfig: {
          reason: { type: 'text', label: 'Причина', required: true },
          delayTime: { type: 'datetime', label: 'Время начала работ', futureTime: true }
        },
        warning: this.getChangePBStateWarnings('BS19')
      })
    },
    BS20_TransmitRequest: function () {
      // TODO : Выбор ответственного исполнителя
      this.$d_ask({
        callback: data => {
          this.askProcessGroup(
            (props) => {
              data = data == null ? props : Object.assign(data, props)
              if (this.taskStatus === 'BS4') {
                data.reportDeletionConfirmed = true
              }
              this.changePBState('BS20', props, 'Ошибка перевода заявки')
            },
            (this.request.group != null)
          )
        },
        header: 'Перевести заявку в Roads?',
        propsConfig: {
          reason: { type: 'text', label: 'Причина', required: true }
        },
        warning: this.getChangePBStateWarnings('BS20')
      })
    },
    BS20_TransmitRequestByEmail: function () {
      const warnings = ['В Roads будет отправлено письмо с запросом перевода на другого исполнителя', 'Текст письма сохранится в комментариях заявки']
      const additionalWarnings = this.getChangePBStateWarnings()
      if (additionalWarnings.length) {
        warnings.push('Если перевод будет одобрен:')
        additionalWarnings.forEach(warning => warnings.push(warning))
      }
      this.$d_ask({
        callback: data => {
          this.sendEmailToTransmitRequestRoads(data.reason)
        },
        header: 'Перевести заявку в Roads?',
        propsConfig: {
          reason: { type: 'text', label: 'Текст письма', required: true }
        },
        warning: warnings
      })
    },
    sendEmailToTransmitRequestRoads: function (messageText) {
      const data = { requestId: this.request.requestId, messageText: messageText }

      this.$q.loading.show({ spinnerColor: 'blue-11' })
      axiosPost({
        url: '/vis/sendEmailToTransmitRequestRoads/onetouch',
        data: data,
        config: { headers: { 'Content-Type': 'application/json' } },
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Письмо для перевода на другого исполнителя отправлено',
            progress: true,
            timeout: 3000
          })
          this.$emit('task-updated')
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message ? response.message : 'Ошибка отправки письма для перевода на другого исполнителя',
            progress: true,
            timeout: 8000
          })
        }
      }).finally(() => {
        this.$q.loading.hide()
      })
    },
    BS21_ReturnRequest: function () {
      this.changePBState('BS21', null, 'Ошибка возврата заявки')
    },
    getChangePBStateWarnings: function (state, warnings = []) {
      if (this.taskStatus === 'BS4' && state !== 'BS5') {
        warnings.push('Активный отчёт об исполнении работ будет удален')
      }
      return warnings
    },
    changePBState: function (state, props, errMsg, onFailure) {
      const bodyFormData = new FormData()
      bodyFormData.set('objectId', this.request.bpContextId)

      if (props != null) {
        bodyFormData.set('props', JSON.stringify(props))
      }

      return axiosPost({
        url: '/service/delta/requestBusinessProcess/' + state,
        data: bodyFormData,
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Успешно изменен статус задания',
            progress: true,
            timeout: 3000
          })
          this.$emit('task-updated')
        },
        onFailure: onFailure || ((response) => {
          this.$q.notify({
            type: 'negative',
            message: errMsg || response.message,
            caption: errMsg ? response.message : null,
            progress: true,
            timeout: 8000
          })
          return Promise.reject(new Error(response.message || errMsg))
        }),
        throws: true
      })
    },
    checkVehicleProvisionRequestsBrigade: async function () {
      this.$q.loading.show({ spinnerColor: 'blue-11' })

      const bodyFormData = new FormData()
      bodyFormData.set('request', this.requestId)

      return axiosPost({
        url: '/service/delta/requestBusinessProcess/special/checkWorkInProgress',
        data: bodyFormData,
        onSuccess: (response) => {
          const vehicleProvisionRequests = response.data.vehicleProvisionRequests || []
          return Promise.resolve(vehicleProvisionRequests)
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        }
      }).finally(() => this.$q.loading.hide())
    },
    BS5_TakeWorkInProgressWithAsk: async function () {
      if (this.user.view === 'mobile' && shouldBlockLoadedReport(this.request, this.report)) {
        showPreviousDeferredReportWarning(this)
        return
      }

      const vehicleProvisionRequests = await this.checkVehicleProvisionRequestsBrigade()

      const propsConfig = {}
      if (vehicleProvisionRequests.length) {
        vehicleProvisionRequests.forEach((forkLift) => {
          if (forkLift.actionType === 'relocationEnd') {
            propsConfig[forkLift.id + '_separator_start'] = {
              type: 'separator',
              label: getExtendedVehicleName(forkLift)
            }
            propsConfig[forkLift.id] = {
              label: 'Завершить передислокацию',
              type: 'boolean',
              value: true
            }
            propsConfig[forkLift.id + '_separator'] = {
              type: 'separator',
              label: ''
            }
          }
        })
      }
      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            const params = { }

            if (vehicleProvisionRequests.length) {
              const convertedForkLifts = []
              vehicleProvisionRequests.forEach((forkLift) => {
                if (forkLift.actionType === 'relocationEnd') {
                  convertedForkLifts.push({
                    id: forkLift.id,
                    apply: data[forkLift.id]
                  })
                }
              })

              params.vehicleProvisionRequests = convertedForkLifts
            }

            this.BS5_TakeWorkInProgress(params)
          }
        },
        header: this.isContractorAssigned ? 'Готовы к сдаче работ?' : 'Начать работы?',
        warning: vehicleProvisionRequests.length ? 'У вас есть спецтехника в передислокации' : null,
        propsConfig: propsConfig,
        buttons: {
          yes: 'Подтвердить',
          cancel2: 'Отмена'
        }
      })
    },
    BS5_TakeWorkInProgress: function (params) {
      // this.askProcessGroup(
      //   (props) => { this.changePBStateReport('BS5', props, 'Выполняются работы') },
      //   (this.request.group != null)
      // )
      this.changePBStateReport('BS5', null, 'Выполняются работы', true, params)
    },
    BS6_SetWorksCompletedWithAsk: function (back = false) { // !!!
      if (back) {
        this.$d_ask({
          callback: () => this.BS6_SetWorksCompleted(),
          header: 'Вернуться к выполнению работ?'
        })
      } else {
        if (this.report.actionsAccess.deferReportCommon) {
          this.askFillOrDeferReport('Завершить работы?', props => {
            // props.deferReport: true/false
            this.BS6_SetWorksCompletedWithServiceObjectMaintenanceNotesTableFastFix(props)
          })
        } else {
          this.$d_ask({
            callback: () => this.BS6_SetWorksCompletedWithServiceObjectMaintenanceNotesTableFastFix(),
            header: 'Завершить работы?'
          })
        }
      }
    },
    BS6_SetWorksCompletedWithServiceObjectMaintenanceNotesTableFastFix: function (props) {
      const serviceObjectMaintenanceNotes = this.report && this.report.maintenanceNotes || []
      const notFixedserviceObjectMaintenanceNotes = serviceObjectMaintenanceNotes.filter(note => note.maintenanceNoteStatus && note.maintenanceNoteStatus.key === 'notFixed')
      if (notFixedserviceObjectMaintenanceNotes && notFixedserviceObjectMaintenanceNotes.length && this.user.view === 'mobile' && this.report.showMaintenanceNote) {
        this.fastFixServiceObjectMaintenanceNotes(notFixedserviceObjectMaintenanceNotes, () => this.BS6_SetWorksCompleted(props))
      } else {
        this.BS6_SetWorksCompleted(props)
      }
    },
    askFillOrDeferReport: function (header, callback) {
      const dialog = this.$d.dialog(this).show({
        maximized: false,
        persistent: true,
        headerLabel: header,
        // unCancellable: true,
        contentComponent: CompleteWorksCard,
        contentProps: {
          request: this.request,
          requestRoles: this.requestRoles,
          report: this.report
        },
        componentHandlers: {
          apply: props => {
            callback(props)
            dialog.hide()
          },
          cancel: () => {
            dialog.hide()
          }
        }
      })
    },
    BS6_SetWorksCompleted: function (props) {
      // this.askProcessGroup(
      //   (props) => { this.changePBStateReport('BS6', props, 'Работы завершены') },
      //   (this.request.group != null)
      // )
      this.changePBStateReport('BS6', props, 'Работы завершены', this.taskStatus !== 'BS7')
    },
    BS7_SetReadinessForDeliveryOfWorksWithAsk: function () {
      // this.askFillOrDeferReport('Готовы к сдаче работ?', props => this.BS7_SetReadinessForDeliveryOfWorks(props))
      this.$d_ask({
        callback: (data) => {
          this.BS7_SetReadinessForDeliveryOfWorks()
        },
        header: 'Готовы к сдаче работ?'
      })
    },
    BS7_onDeferReportButton: function () {
      this.$q.loading.show({ spinnerColor: 'blue-11' })
      this.loading = true
      checkDeferralAccess(this.report)
        .finally(() => {
          this.$q.loading.hide()
        })
        .then(accessData => {
          if (accessData.deferReport) {
            this.report.actionsAccess.deferReport = true

            this.$d_ask({
              callback: () => {
                this.BS7_SetReadinessForDeliveryOfWorks({
                  deferReport: true
                })
              },
              header: 'Отложить заполнение отчёта?'
            })
          } else {
            this.$d_ask({
              warning: ['Сначала заполните предыдущий отложенный отчёт.', 'Разрешено не более одного отложенного отчёта.'],
              buttons: {
                cancel2: 'Закрыть'
              }
            })
          }
        })
    },
    BS7_SetReadinessForDeliveryOfWorks: function (props) {
      this.changePBStateReport('BS7', props, null)
    },
    BS8_AcceptWorks: function () {
      if (this.report.defaultRemark == null || this.report.defaultRemark === '') {
        this.changePBStateReport('BS8', null, 'Принять работы', false)
      } else {
        this.$d_ask({
          callback: data => {
            this.changePBStateReport('BS8', { reportConfig: { acceptedWithFlaws: true, flawsDescr: data.remark } }, 'Принять работы', false)
          },
          header: 'Принять работы с замечаниями?',
          propsConfig: {
            remark: { type: 'text', label: 'Замечание к отчёту', value: this.report.defaultRemark, required: true }
          }
        })
      }
    },
    BS14_or_BS15_Rework: function (reworkKey) {
      const nextState = reworkKey === 'reworkServiceObject' ? 'BS14' : 'BS15'
      const windowHeader = reworkKey === 'reworkServiceObject' ? 'Доработка объекта' : 'Доработка отчёта'
      const onlyDeferred = this.report.closedManually === true
      const defaultRemark = this.report.defaultRemark
      this.$refs.askReworkPropsWindow.ask((data) => {
        this.changePBStateReport(nextState, {
          reason: data.reworkReason,
          deferred: data.deferred,
          reportConfig: data,
          force: true
        }, 'Ошибка задания доработок', false)
      }, windowHeader, defaultRemark)
    },
    BS15_ReworkReportByExecutor: function () {
      this.$d_ask({
        callback: data => {
          this.changePBStateReport('BS15', {
            reason: data.reason,
            deferred: false,
            reportConfig: {},
            force: true
          }, 'Ошибка перехода к доработке отчёта', false)
        },
        header: 'Доработать отчёт?',
        propsConfig: {
          reason: { type: 'text', label: 'Причина', value: 'По решению исполнителя', required: true }
        }
      })
    },
    cancelWorksExecutionWithAsk: function () {
      this.$d_ask({
        callback: (data) => {
          this.cancelWorksExecution(data)
        },
        header: this.report.departureNumber !== 0 ? 'Выполнить срочное завершение выезда?' : 'Прервать выполнение работ и сдать отчёт?',
        propsConfig: { reason: { type: 'text', label: 'Причина', required: true } }
      })
    },
    cancelWorksExecution: function (data) {
      const hasDeparture = this.report.departureNumber !== 0

      let url
      const bodyFormData = new FormData()
      if (data.reason) {
        bodyFormData.set('reason', data.reason)
      }
      bodyFormData.set('request', this.request.requestId)
      if (hasDeparture) {
        url = '/service/delta/brigade/cancelCurrentDeparture/' + this.report.brigadeId
      } else {
        url = '/service/delta/requestBusinessProcess/special/cancelWorksExecution'
      }

      this.$q.loading.show({ spinnerColor: 'blue-11' })
      axiosPost({
        url: url,
        data: bodyFormData,
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: hasDeparture ? 'Объект покинут' : 'Работы прерваны',
            progress: true,
            timeout: 3000
          })
          this.$emit('report-updated')
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        }
      }).finally(() => {
        this.$q.loading.hide()
      })
    },
    askProcessGroup: function (callback, condition) {
      if (condition) {
        this.$d_ask({
          callback: (data, action) => {
            if (action === 'yes' || action === 'no') {
              const props = {
                groupProcessing: (action === 'yes'),
                groupProcessingInitiator: (action === 'yes')
              }
              callback(props)
            }
          },
          header: 'Применить для всех заявок сводного отчёта?',
          buttons: {
            yes: 'Да',
            no: 'Нет',
            cancel: 'Отмена'
          }
        })
      } else {
        callback({
          groupProcessing: false,
          groupProcessingInitiator: false
        })
      }
    },
    changePBStateReport: async function (state, props = {}, errMsg, saveChanges = true, propsParams) {
      this.$q.loading.show({ spinnerColor: 'blue-11' })
      let isChanged = false
      if (saveChanges) {
        try {
          isChanged = await this.saveChanges()
        } catch (error) {
          this.$q.loading.hide()

          console.log(error)
          this.$q.notify({
            type: 'negative',
            message: error.message || 'Ошибка сохранения отчёта',
            progress: true,
            timeout: 8000
          })
          return
        }
      }

      const isRequestBP = state.startsWith('BS')
      let businessProcess, objectId
      if (isRequestBP) {
        businessProcess = 'requestBusinessProcess'
        objectId = this.request.bpContextId ? this.request.bpContextId : this.report.bpContextId
      } else {
        businessProcess = 'requestReport'
        objectId = this.report.id
      }

      const bodyFormData = new FormData()
      bodyFormData.set('objectId', objectId)

      if (propsParams != null) {
        props = {
          ...props,
          ...propsParams
        }
      }
      if (props != null) {
        bodyFormData.set('props', JSON.stringify(props))
      }

      const bpChangeResult = {
        businessProcess,
        objectId,
        props,
        // ===
        reportChanged: isChanged,
        result: null,
        status: null
      }

      await axiosPost({
        url: '/service/delta/' + businessProcess + '/' + state,
        data: bodyFormData,
        onSuccess: response => {
          console.log('Статус задания изменен', state, props, response)
          this.$q.notify({
            type: 'positive',
            message: 'Статус задания изменен',
            progress: true,
            timeout: 3000
          })

          bpChangeResult.reportChanged = true // TODO по ответу сервера
          bpChangeResult.result = response.data && response.data.result || null
          bpChangeResult.status = response.data && response.data.status || null
        },
        onFailure: (response) => {
          errMsg = response.message || errMsg
          this.$q.notify({
            type: 'negative',
            message: errMsg,
            progress: true,
            timeout: 8000
          })
          bpChangeResult.status = 'error'
        }
      })
        .finally(() => {
          this.$q.loading.hide()
          if (bpChangeResult.reportChanged || bpChangeResult.status == 'success') {
            if (isRequestBP) {
              this.$emit('task-updated', bpChangeResult)
            } else {
              this.$emit('report-updated', bpChangeResult)
            }
          }
        })
    },
    saveChanges: async function () {
      const report = this.report
      if (report != null) {
        return await report._reportManager.saveChanges({ target: this })
      }
      return false
    },

    // Усиление
    changeReinforcementRequestStateWithAsk: async function (actionConfig) {
      if (!actionConfig || !actionConfig.nextState) {
        return
      }
      if (actionConfig.checkReinforcementFn) {
        const continueAction = await actionConfig.checkReinforcementFn()
        if (continueAction !== true) {
          return
        }
      }

      this.$d_ask({
        callback: (data) => {
          this.changeBPState(actionConfig.id, actionConfig.nextState)
        },
        header: actionConfig.message
      })
    },
    getReinforcementActions: function (reinforcementInfo, useFullMessage) {
      const actionsConfigs = []

      // Действие по умолчанию
      let nextState
      if (reinforcementInfo.state === 'RI4') {
        nextState = 'RI3'
      } else {
        nextState = 'RI' + (Number.parseInt(reinforcementInfo.state.substring(2)) + 1)
      }
      const nextStateActionConfig = this.getReinforcementActionConfig(reinforcementInfo, nextState, useFullMessage)
      if (nextStateActionConfig) {
        if (reinforcementInfo.state === 'RI1' && nextState === 'RI2' && reinforcementInfo.requestBPState === 'BS3') {
          nextStateActionConfig.style = 'color: black; background-color: lightgray;'
          nextStateActionConfig.checkReinforcementFn = () => {
            return axiosGet({
              url: '/service/delta/request/getRequest?id=' + reinforcementInfo.requestId,
              onSuccess: (response) => {
                if (response.data.result.bpStateId !== 'BS3') {
                  return true
                }

                this.$q.notify({
                  type: 'negative',
                  message: 'Заявка еще не принята к исполнению ответственным бригадиром',
                  progress: true,
                  timeout: 8000
                })
                return false
              },
              onFailure: () => {
                return false
              }
            })
          }
        } else {
          nextStateActionConfig.style = 'color: white; background-color: #67c23a; border-color: #63ba38;'
        }

        actionsConfigs.push(nextStateActionConfig)
      }

      // Отклонение заявки
      if (reinforcementInfo.state === 'RI1' || reinforcementInfo.state === 'RI2') {
        const cancelActionConfig = this.getReinforcementActionConfig(reinforcementInfo, 'RI5', useFullMessage)
        cancelActionConfig.style = 'color: #ffffff; background-color: #f56c6c;'
        actionsConfigs.push(cancelActionConfig)
      }
      return actionsConfigs
    },
    getReinforcementActionConfig: function (reinforcementInfo, nextState, useFullMessage) {
      const actionConfig = Object.assign({
        nextState
      }, reinforcementInfo)

      if (nextState === 'RI2') {
        actionConfig.label = 'Принять к исполнению'
        actionConfig.message = useFullMessage ? 'Принять к исполнению Заявку № ' + reinforcementInfo.requestNumber + '?' : (actionConfig.label + '?')
      } else if (nextState === 'RI3') {
        if (reinforcementInfo.state === 'RI2') {
          actionConfig.label = 'Начать работы'
          actionConfig.message = useFullMessage ? 'Начать работы по Заявке № ' + reinforcementInfo.requestNumber + '?' : (actionConfig.label + '?')
        } else if (reinforcementInfo.state === 'RI4') {
          actionConfig.label = 'Вернуться к работам'
          actionConfig.message = useFullMessage ? 'Вернуться к работам по Заявке № ' + reinforcementInfo.requestNumber + '?' : (actionConfig.label + '?')
        }
      } else if (nextState === 'RI4') {
        actionConfig.label = 'Завершить работы'
        actionConfig.message = useFullMessage ? 'Завершить работы по Заявке № ' + reinforcementInfo.requestNumber + '?' : (actionConfig.label + '?')
      } else if (nextState === 'RI5') {
        actionConfig.label = 'Отклонить'
        actionConfig.message = useFullMessage ? 'Отклонить Заявку № ' + reinforcementInfo.requestNumber + '?' : (actionConfig.label + ' заявку?')
      }
      return actionConfig
    },
    saveRequestFromReport: function () {
      this.$q.loading.show({ spinnerColor: 'blue-11' })

      const tempRequest = convertRequestToServer(this.request, false, this.requestInitial)
      const tempRequestStr = JSON.stringify(tempRequest)
      const bodyFormData = new FormData()
      bodyFormData.set('requestId', this.request.requestId)
      bodyFormData.set('properties', tempRequestStr)

      axiosPost({
        url: '/service/delta/request/edit',
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: function (response) {
          this.$q.notify({
            type: 'positive',
            message: 'Заявка сохранена',
            progress: true,
            timeout: 3000
          })
        }.bind(this),
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })
        },
        msgTarget: this
      }).finally(() => {
        this.$q.loading.hide()
      })
    },
    showAdjacentObjectsRequests: function () {
      const dialog = this.$d.dialog(this).show({
        maximized: true,
        persistent: true,
        headerLabel: this.user.view === 'mobile' ? 'Заявки на смежных объектах' : ('Заявки на объектах, смежных с ' + this.request.serviceObject.name),
        contentComponent: RequestAdjacentObjectsRequests,
        contentProps: {
          requestId: this.request.requestId,
          objectId: this.request.serviceObjectId,
          objectType: this.request.serviceObjectType,
          serviceObjectName: this.request.serviceObject.name
        },
        componentHandlers: {
          close: () => {
            dialog.hide()
          }
        }
      })
    }
  }
}
